export const ERROR_CODE_ACCOUNT_EXISTS = 'auth/email-already-in-use';
export const ERROR_MSG_ACCOUNT_EXISTS = `An account with this Email address already exists. Please try a forgotten password request to recover your account.`;
